<template>
    <div class="panel panel-default panel-body">
            <form-wizard 
                    ref ="formWizard"
                    @on-loading="onLoading"
                    @on-complete="onComplete"
                    @on-validate="onValidate"
                    @on-change="onChange"
                    @on-error="onWizError"
                    :color="formSchema.form.color"
                    :error-color="formSchema.form.errorColor" 
                    :shape="formSchema.form.shape"
                    :stepSize="formSchema.form.stepSize"
                    :validate-on-back="formSchema.form.validateOnBack"
                    :nextButtonText="formSchema.form.nextButtonText"
                    :backButtonText="formSchema.form.backButtonText"
                    :finishButtonText="formSchema.form.finishButtonText"
                    :transition="formSchema.form.transition"
                    :title="formSchema.form.title"
                    :subtitle="formSchema.form.subtitle"
                    :start-index="startIndex"
                    >
                <h2 slot="title">{{ formSchema.form.wizardTitle }}</h2>  
                
                <!--SLOTS-->
                <template v-for="slotObj in formSchema.form.slots||[]" 
                    :slot="slotObj.slot" 
                    slot-scope="props">
                        <html-renderer-old
                            :app="$store.state.site.content.app"  
                            :params="$store.state.site.content.params"  
                            :template="slotObj.html" 
                            :props="props" 
                            :model="formSchema.model"
                        >
                    </html-renderer-old>
                </template>
                
                <!--TAB CONTENTS-->
                <tab-content v-for="(page, index) in formSchema.pages"  v-if="('visible' in page ) ? page.visible : 1" 
                    :key="index" 
                    :title="page.title"
                    :icon="page.icon"
                    :before-change="onBeforeChange"
                    :ref="'tab_'+index"
                    >
                    <vue-form-generator 
                        :ref="'vfg_'+index"
                        :schema="page.schema" 
                        :options="formSchema.options" 
                        :model="formSchema.model"
                        @validated="onVfgValidated"
                    >
                    </vue-form-generator>
                </tab-content>
                
                <div v-if="errors">
                    <!--<span v-for="error in errors" class="error">{{error.field.label}} - {{error.error}}<br></span>-->
                </div>
                
            </form-wizard>
    </div>
        
</template>

<script>
    import { FormWizard, TabContent } from 'vue-form-wizard'
    
    import { EventBus } from 'Js/eventBus';
    // https://github.com/cristijora/vue-form-wizard
    
    // on bypassing tabs: https://jsfiddle.net/bt5dhqtf/1278/
    
    export default {
        name: "wizard",
        mounted() {
            if (this.formSchema.form.wizardEnableAllTabs) {
                var tabs = this.$refs.formWizard.tabs;
                tabs.forEach((tab) => tab.checked = true)
                this.$refs.formWizard.maxStep = tabs.length;
            }
        },
        
        methods: {
            onLoading: function() {
                return new Promise((resolve, reject) => {
                    resolve(true)
                })
            },

            // Called by vfg comp. when it is valid ( multiple tabs call this)
            onVfgValidated: function(isValid, errors) {
                // console.log("onVfgValidated result: ", isValid, ", Errors:", errors);
                // this.errors = errors
                Vue.set(this , "errors", errors )
            },

            onBeforeChange: function() {
                debugger
                if (typeof this.formSchema.form.wizardBeforeChange === "function") {
                    this.formSchema.form.wizardBeforeChange()
                    // return false
                }

                var currentTab = this.$refs.formWizard.activeTabIndex
                var vfgs = _.filter(this.$refs,function(o,index) {  return index.startsWith("vfg") })
                var errors = !vfgs[currentTab][0].validate() // validate just this tab
                debugger
                if( errors && !this.formSchema.form.wizardAllowInvalidTabChange) {
                    return false
                }

                this.$parent.formSchema.state.currentTabIndex = this.$refs.formWizard.activeTabIndex
                // change to emit? bt needs promise
                let myPromise = this.$parent.onTabChange()
                return myPromise

            },
            
            onChange: function(prevIndex, nextIndex) {
                debugger
                if (typeof this.formSchema.form.wizardOnChange === "function") {
                    this.formSchema.form.wizardOnChange(prevIndex, nextIndex)
                    return 
                }
            },

            onValidate: function(isValid, tabIndex) {
                // called by Vue Wizard
                // Called whenever the execution of a before-change method is completed. 
                // The event sends along a Boolean which represents the validation result 
                // as well as an int with te tab index. this.$emit('on-validate', 
                // alert('at wizard validate')
                return 
            },

            validate: function() {
                // Called by parents when it needs to validate this wizard,
                // not needed since the tab change is run before the finish
                return true
            },

            onComplete: function(){
                EventBus.$emit('runOnCompleteHook') 
            },

            onWizError: function(error) {
                // this is called by the wiz when a promise is rejected,
                // can translate errors in future
            },
            
            namedAction: function(name, options) {
      EventBus.$emit('processNamedAction', {
        name,
        options
      })
    }

        },

        computed: {
            startIndex () {
                return this.formSchema.state && this.formSchema.state.startIndex ? this.formSchema.state.startIndex: 0
            }
        },
        
        components: {
            FormWizard,
            TabContent,
            "vue-form-generator": VueFormGenerator.component
        },

        props: ['formSchema'],

        data: function() {
            return {
                errors: []
            }
        }
    }
</script>

<style src="vue-form-wizard/dist/vue-form-wizard.min.css"></style>

<style type="text/css">
/*.error {*/
/*    color: red;*/
/*}*/
/*Not sure why this was added*/
/*.error {*/
/*    color: #e74c3c;*/
/*    font-size: 20px;*/
/*    display: flex;*/
/*    justify-content: center;*/
/*}*/

</style>

